import { format, isValid, parse } from 'date-fns';

/**
 * Formats a date string to the German locale date format (dd.MM.yyyy).
 *
 * @param {string} dateString - The date string to format.
 * @returns {string} - The formatted date string.
 */
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};
export const formatTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleTimeString('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
  });
};
export const formatDateTime = (dateString) => {
  return `${formatDate(dateString)} ${formatTime(dateString)}`;
};

/**
 * Converts a date string from 'YYYY-MM-DD' format to 'dd.MM.yyyy' format.
 *
 * @param {string} dateString - The date string in 'YYYY-MM-DD' format.
 * @returns {string} - The date string in 'dd.MM.yyyy' format.
 */
export const parseEIVDateStringToEfixDateString = (dateString) => {
  if (!dateString) {
    return '';
  }
  const date = parse(dateString, 'yyyy-MM-dd', new Date());
  return isValid(date) ? format(date, 'dd.MM.yyyy') : dateString;
};

/**
 * Converts a date string from 'dd.MM.yyyy' format to 'yyyy-MM-dd' (ISO) format.
 * Returns the original string if it doesn't match the expected pattern.
 *
 * @param {string} value
 * @returns {string}
 */
export const toISODateString = (value) => {
  if (!value) return value;
  const match = value.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  if (!match) return value;
  return `${match[3]}-${match[2]}-${match[1]}`;
};

export const getTodayMidnightDate = () => new Date().setHours(0, 0, 0, 0);
